export default __webpack_public_path__ + "static/media/ic_deliver.19d63fc9.svg";